import request from '@/router/axios'

const getList = (current, size, params, deptId) => request({
  url: '/api/mcc-worker/team/page',
  method: 'get',
  params: {
    ...params,
    current,
    size,
    deptId,
  },
})

// const update = params => request({
//   url: '/api/mcc-worker/team/update',
//   method: 'post',
//   data: params,
// })
const getTeamsTreeList = (current, size, params) => request({
  url: '/api/mcc-worker/team/teamListAll',
  //   url: '/api/mcc-worker/team/teamWorkerList',
  method: 'get',
  params: {
    current,
    size,
    ...params,
  },
})

// 获取包括工长工人列表
const getTeamsTreeList1 = (current, size, params) => request({
  url: '/api/mcc-worker/team/teamWorkerList2',
  method: 'get',
  params: {
    current,
    size,
    ...params,
  },
})

// 未加入班组工人列表
const getWorkerNoList = (current, size, params) => request({
  url: '/api/mcc-worker/employment/noTeamList',
  method: 'get',
  params: {
    current,
    size,
    ...params,
  },
})

// 保存班组成员
const saveTeams = params => request({
  url: '/api/mcc-worker/teammember/addTeamMembers',
  method: 'post',
  params,
})
// 删除班组成员
const removeTeams = ids => request({
  url: '/api/mcc-worker/teammember/remove',
  method: 'post',
  params: {
    ids,
  },
})
// 获取speciaList
const getSpeciaList = () => request({
  url: '/api/mcc-worker/specialist/list',
  method: 'get',
})

// 获取当前工长班组下成员信息
export const getTeamsList = (current, size, params, deptId) => request({
  url: '/api/mcc-worker/team/teamWorkerList',
  method: 'get',
  params: {
    ...params,
    current,
    size,
    deptId,
  },
})

const teamChangeProject = params => request({
  url: '/api/mcc-worker/team/teamChangeProject',
  method: 'post',
  params,
})

const teamChangeSpecialist = params => request({
  url: '/api/mcc-worker/team/teamChangeSpecialist',
  method: 'post',
  params,
})

export default {
  getList,
  getWorkerNoList,
  saveTeams,
  getTeamsTreeList,
  getTeamsTreeList1,
  getSpeciaList,
  removeTeams,
  teamChangeProject,
  teamChangeSpecialist,
}
